// ثوابت مشترک صفحات لید (لیست، کانبان، جزئیات).
// مقادیر عددی باید با Enums.LeadStatus / LeadPriority / LeadActivityType در بک‌اند یکی بمانند.

export const STATUS = [
  {
    value: 0, text: 'جدید', variant: 'primary', color: '#7367f0',
  },
  {
    value: 1, text: 'تماس گرفته شد', variant: 'info', color: '#00cfe8',
  },
  {
    value: 4, text: 'در حال مذاکره', variant: 'warning', color: '#ff9f43',
  },
  {
    value: 2, text: 'موفق', variant: 'success', color: '#28c76f',
  },
  {
    value: 3, text: 'ناموفق', variant: 'danger', color: '#ea5455',
  },
]

export const PRIORITY = [
  {
    value: 0, text: 'کم', variant: 'light-secondary', icon: 'ChevronDownIcon',
  },
  {
    value: 1, text: 'متوسط', variant: 'light-warning', icon: 'MinusIcon',
  },
  {
    value: 2, text: 'زیاد', variant: 'light-danger', icon: 'ChevronUpIcon',
  },
]

export const SOURCE = [
  { value: 'manual', text: 'ثبت دستی' },
  { value: 'contact', text: 'فرم تماس' },
  { value: 'consult', text: 'درخواست مشاوره' },
  { value: 'funnel', text: 'قیف فروش' },
  { value: 'form', text: 'فرم عمومی' },
  { value: 'chatbot', text: 'چت‌بات' },
  // ابزارهای رایگان سایت — عمداً جدا هستند تا نرخ تبدیل هر ابزار قابل مقایسه باشد.
  // مقادیر باید با ToolRunService.LeadSource در بک‌اند یکی بمانند.
  { value: 'tool-seo', text: 'ابزار بررسی سئو' },
  { value: 'tool-speed', text: 'ابزار تست سرعت' },
  { value: 'tool-enamad', text: 'ابزار سنجش نماد' },
  { value: 'tool-legal', text: 'ابزار تولید قوانین' },
  { value: 'tool-ssl', text: 'ابزار SSL رایگان' },
]

// لیدهایی که خودشان از ابزار آمده‌اند: واجدشرایط‌ترین‌ها (سایت دارند و مشکلشان را می‌دانیم)
export const isToolSource = source => String(source || '').startsWith('tool-')

export const TOOL_ICON = {
  'tool-seo': 'SearchIcon',
  'tool-speed': 'ZapIcon',
  'tool-enamad': 'ShieldIcon',
  'tool-legal': 'FileTextIcon',
  'tool-ssl': 'LockIcon',
}

// پیشنهادهای کانال — کاربر می‌تواند مقدار دلخواه هم تایپ کند
export const CHANNEL = [
  'دیوار',
  'تماس تلفنی',
  'اینستاگرام',
  'واتساپ',
  'تلگرام',
  'معرفی مشتری',
  'جستجوی گوگل',
  'نمایشگاه / حضوری',
  'شبا / همکار',
  'سایر',
]

export const ACTIVITY_TYPE = [
  {
    value: 0, text: 'یادداشت', icon: 'FileTextIcon', variant: 'secondary',
  },
  {
    value: 1, text: 'تماس تلفنی', icon: 'PhoneIcon', variant: 'primary',
  },
  {
    value: 2, text: 'پیام / واتساپ', icon: 'MessageCircleIcon', variant: 'success',
  },
  {
    value: 3, text: 'جلسه', icon: 'UsersIcon', variant: 'info',
  },
  {
    value: 4, text: 'ارسال پیش‌فاکتور', icon: 'FileIcon', variant: 'warning',
  },
]

// لاگ‌های خودکار سیستم (فقط برای نمایش در تایم‌لاین؛ از پنل ثبت نمی‌شوند)
export const SYSTEM_ACTIVITY_TYPE = [
  {
    value: 10, text: 'تغییر وضعیت', icon: 'RefreshCwIcon', variant: 'warning',
  },
  {
    value: 11, text: 'تخصیص کارشناس', icon: 'UserCheckIcon', variant: 'info',
  },
  {
    value: 12, text: 'زمان‌بندی پیگیری', icon: 'ClockIcon', variant: 'primary',
  },
  {
    value: 13, text: 'ایجاد لید', icon: 'PlusCircleIcon', variant: 'success',
  },
  {
    value: 14, text: 'ویرایش لید', icon: 'EditIcon', variant: 'secondary',
  },
]

export const FOLLOW_UP = [
  { value: 0, text: 'عقب‌افتاده' },
  { value: 1, text: 'امروز' },
  { value: 2, text: 'تا هفته آینده' },
  { value: 3, text: 'بدون زمان پیگیری' },
]

const find = (list, value) => list.find(x => x.value === value)

export const statusOf = value => find(STATUS, value) || {
  value, text: 'نامشخص', variant: 'secondary', color: '#b9b9c3',
}

export const priorityOf = value => find(PRIORITY, value) || PRIORITY[0]

export const sourceOf = value => find(SOURCE, value) || { value, text: value || 'نامشخص' }

export const activityOf = value => find(ACTIVITY_TYPE, value)
  || find(SYSTEM_ACTIVITY_TYPE, value)
  || {
    value, text: 'فعالیت', icon: 'CircleIcon', variant: 'secondary',
  }

// فعالیت‌های ۱۰ به بالا لاگ سیستم‌اند و قابل حذف نیستند
export const isSystemActivity = value => value >= 10

export const waLink = mobile => {
  const m = String(mobile || '').replace(/[^0-9]/g, '')
  if (!m) return null
  const intl = m.startsWith('0') ? `98${m.substring(1)}` : m
  return `https://wa.me/${intl}`
}

export default {
  STATUS,
  PRIORITY,
  SOURCE,
  TOOL_ICON,
  isToolSource,
  CHANNEL,
  ACTIVITY_TYPE,
  SYSTEM_ACTIVITY_TYPE,
  FOLLOW_UP,
  statusOf,
  priorityOf,
  sourceOf,
  activityOf,
  isSystemActivity,
  waLink,
}
